module.exports = __webpack_public_path__ + "img/page-01.4e2b75bf.jpg";